<template>
    <v-data-table
        :headers="useHeaders"
        :items="locations"
        :items-per-page-options="useTableOptions(locations?.length)"
        disable-sort
        density="compact"
        class="elevation-1 mb-2"
        :hide-default-footer="locations?.length < 10"
    />
    <v-btn data-cy="add-locations" class="width-max-content" @click="selectCountries()">
        {{ $t('add') }}
    </v-btn>
    <ModalWrapper v-model="isShowModal">
        <template v-slot:title>
            {{ $t('choose_countries') }}
        </template>
        <template v-slot:content>
            <v-autocomplete
                v-model="selectedCountries"
                :items="useCountries"
                item-title="countryName"
                item-value="countryId"
                closable-chips
                clearable
                multiple
                data-cy="country-list"
                return-object
                @update:model-value="selectedCountries.sort((a, b) => a.countryName.localeCompare(b.countryName))"
            />
        </template>
        <template v-slot:btns>
            <v-btn data-cy="add-locations" variant="flat" @click="addLocations">
                {{ $t('apply') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script setup lang="ts">
    import {useTableOptions} from '~/composables/helpers'

    const isShowModal = ref<boolean>(false)
    const selectedCountries = ref([])

    const locations = defineModel<any>()

    const {t} = useI18n()

    const useHeaders = computed(() => {
        return [{title: t('location'), value: 'countryName', minWidth: '120px'}]
    })

    const selectCountries = () => {
        selectedCountries.value = locations.value
        isShowModal.value = true
    }

    const addLocations = () => {
        isShowModal.value = false
        locations.value = selectedCountries.value
    }

    const resetLocations = () => {
        selectedCountries.value = []
        isShowModal.value = false
    }

    const useCountries = computed(() => {
        return runtimeStore.countries.map(({id, name}) => ({countryName: name, countryId: id}))
    })
</script>
